const html = require('choo/html');
const modal = require('./modal');

module.exports = function(state, emit) {
  return html`
    <main class="main">

    </main>
  `;
};
